// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VaJXY","text":"style_text__WGJdd","actions":"style_actions__nso7C","actions_btn":"style_actions_btn__brLuu"};